import type { HTTPError } from "ky";
import { z } from "zod";

export const RTFailedFetchError = z.object({
  // This is the only way we have to detect a network related error than can be
  // thrown by fetch (and therefore Ky)
  // cf. https://developer.mozilla.org/en-US/docs/Web/API/fetch#exceptions
  name: z.literal("TypeError"),
  message: z.literal("Failed to fetch"),
});

export const isJsonHttpError = (cause: HTTPError) =>
  cause.response.headers.get("content-type")?.includes("application/json");
